import {
  S1_SELF_DETERMINED_ORDER,
  S3_ADVERSE_IMPACT_ORDER,
  S3_SFDR_ORDER,
  S3_TAXONOMY_ORDER,
  type ConsilioAnswers,
  type ConsilioSustainabilityAnswers,
} from './answers';

const canonical = (orders: number[] | undefined): number[] =>
  [...new Set(orders ?? [])].sort((a, b) => a - b);

export const isSelfDetermined = (
  value?: ConsilioSustainabilityAnswers,
): boolean => value?.s1 === S1_SELF_DETERMINED_ORDER;

const opens = (
  value: ConsilioSustainabilityAnswers | undefined,
  characteristic: number,
): boolean => isSelfDetermined(value) && !!value?.s3?.includes(characteristic);

export const opensTaxonomy = (value?: ConsilioSustainabilityAnswers): boolean =>
  opens(value, S3_TAXONOMY_ORDER);

export const opensSfdr = (value?: ConsilioSustainabilityAnswers): boolean =>
  opens(value, S3_SFDR_ORDER);

export const opensAdverseImpact = (
  value?: ConsilioSustainabilityAnswers,
): boolean => opens(value, S3_ADVERSE_IMPACT_ORDER);

export const pruneSustainability = (
  value: ConsilioSustainabilityAnswers | undefined,
): ConsilioSustainabilityAnswers | undefined => {
  if (value?.s1 === undefined) return undefined;

  if (!isSelfDetermined(value)) return { s1: value.s1 };

  const pruned: ConsilioSustainabilityAnswers = {
    s1: value.s1,
    s3: canonical(value.s3),
  };

  if (value.s2 !== undefined) pruned.s2 = value.s2;
  if (opensTaxonomy(value) && value.s4 !== undefined) pruned.s4 = value.s4;
  if (opensSfdr(value) && value.s5 !== undefined) pruned.s5 = value.s5;
  if (opensAdverseImpact(value)) pruned.s6 = canonical(value.s6);

  return pruned;
};

export const isSustainabilityComplete = (answers: ConsilioAnswers): boolean => {
  const value = pruneSustainability(answers.sustainability);

  if (!isSelfDetermined(value)) return true;

  return (
    value?.s2 !== undefined &&
    !!value.s3?.length &&
    (!opensTaxonomy(value) || value.s4 !== undefined) &&
    (!opensSfdr(value) || value.s5 !== undefined) &&
    (!opensAdverseImpact(value) || !!value.s6?.length)
  );
};
